import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

export const DocumentRowSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.md}
			px={theme.spacingTokens.lg}
			py={1.4}
		>
			<Skeleton
				variant="rounded"
				width={40}
				height={40}
				animation="wave"
				sx={{ borderRadius: "12px", flexShrink: 0 }}
			/>
			<Stack flex={1} minWidth={0} gap={theme.spacingTokens.xs}>
				<Skeleton variant="text" width="55%" height={18} animation="wave" />
				<Skeleton variant="text" width="30%" height={14} animation="wave" />
			</Stack>
			<Skeleton
				variant="circular"
				width={theme.iconSize.sm}
				height={theme.iconSize.sm}
				animation="wave"
				sx={{ flexShrink: 0 }}
			/>
		</Stack>
	);
};
